import { RawCustomProject } from '@entities/CustomProject/Types';
import { QuestionTypeEnum } from '@shared/Enums/QuestionTypeEnum';

export const BOMProjectExampleData: RawCustomProject = {
    id: 576,
    title: 'BOM Example',
    data: {
        templates: [
            {
                id: 116,
                data: {
                    fragments: [
                        {
                            id: 86,
                            qty: null,
                            data: {
                                '0': {
                                    key: 'L',
                                    value: 10,
                                    select: QuestionTypeEnum.INPUT,
                                    answers: [
                                        {
                                            title: '10',
                                            value: 10,
                                            selected: true,
                                        },
                                    ],
                                    question: 'Length of area to be paved (m)',
                                },
                                '1': {
                                    key: 'W',
                                    value: 10,
                                    select: QuestionTypeEnum.INPUT,
                                    answers: [
                                        {
                                            title: '10',
                                            value: 10,
                                            selected: true,
                                        },
                                    ],
                                    question: 'Width of area to be paved (m)',
                                },
                                fragments: [],
                                item_types: [
                                    {
                                        id: 689,
                                        qty: 5500,
                                        data: null,
                                        slug: null,
                                        tool: false,
                                        unit: 'psc',
                                        fair_market_price: null,
                                        items: [
                                            {
                                                id: 12177,
                                                qty: 5500,
                                                unit: 'each',
                                                price: '2.652174',
                                                title: 'Paver Cement Interlocking 60mm-grey',
                                                admined: true,
                                                packaging: [],
                                                created_at:
                                                    '2024-04-19T19:41:12.000000Z',
                                                deleted_at: null,
                                                updated_at:
                                                    '2025-03-04T12:57:32.000000Z',
                                                qty_from_store: 852,
                                                ordered_qty: 0,
                                                percentage: 0,
                                                galleries: [],
                                                pivot: undefined,
                                                uuid: undefined,
                                            },
                                        ],
                                        labor: false,
                                        title: 'Cement Pavers',
                                        created_at:
                                            '2024-08-01T07:18:32.000000Z',
                                        deleted_at: null,
                                        updated_at:
                                            '2025-02-19T10:28:23.000000Z',
                                        qty_formula: 'f(x) = %L%*%W%*55',
                                        ordered_qty: 0,
                                        percentage: 0,
                                    },
                                    {
                                        id: 854,
                                        qty: 6,
                                        data: null,
                                        slug: null,
                                        tool: false,
                                        unit: 'm³',
                                        fair_market_price: null,
                                        items: [],
                                        labor: false,
                                        title: 'River Sand 1/2 Cube',
                                        created_at:
                                            '2024-08-01T07:18:44.000000Z',
                                        deleted_at: null,
                                        updated_at:
                                            '2025-02-26T13:13:01.000000Z',
                                        qty_formula: 'f(x) = %L%*%W%*0.028*2',
                                        ordered_qty: 0,
                                        percentage: 0,
                                    },
                                    {
                                        id: 1715,
                                        qty: 100,
                                        data: null,
                                        slug: null,
                                        tool: false,
                                        unit: 'each',
                                        items: [],
                                        labor: true,
                                        title: 'Rip and compact for paving',
                                        created_at:
                                            '2025-01-13T07:48:12.000000Z',
                                        deleted_at: null,
                                        updated_at:
                                            '2025-01-13T07:58:10.000000Z',
                                        qty_formula: 'f(x) = %L%*%W%',
                                        ordered_qty: 0,
                                        percentage: 0,
                                        fair_market_price: null,
                                    },
                                    {
                                        id: 1716,
                                        qty: 10,
                                        data: null,
                                        slug: null,
                                        tool: false,
                                        unit: 'each',
                                        fair_market_price: null,
                                        items: [],
                                        labor: true,
                                        title: '1m wide concrete apron',
                                        created_at:
                                            '2025-01-13T07:48:55.000000Z',
                                        deleted_at: null,
                                        updated_at:
                                            '2025-01-13T07:48:55.000000Z',
                                        qty_formula: 'f(x) = %L%*%W% * 0.1',
                                        ordered_qty: 0,
                                        percentage: 0,
                                    },
                                    {
                                        id: 1714,
                                        qty: 100,
                                        data: null,
                                        slug: null,
                                        tool: false,
                                        unit: 'each',
                                        items: [],
                                        labor: true,
                                        title: 'Placing and compacting paving bricks',
                                        created_at:
                                            '2025-01-13T07:47:26.000000Z',
                                        deleted_at: null,
                                        updated_at:
                                            '2025-01-13T07:47:26.000000Z',
                                        qty_formula: 'f(x) = %L%*%W%',
                                        ordered_qty: 0,
                                        percentage: 0,
                                        fair_market_price: null,
                                    },
                                ],
                                var_mapping: null,
                            },
                            slug: null,
                            title: 'Paving',
                            frozen: false,
                            publish: true,
                            created_at: '2024-11-13T18:28:00.000000Z',
                            deleted_at: null,
                            updated_at: '2025-02-27T09:04:20.000000Z',
                        },
                        {
                            id: 114,
                            qty: null,
                            data: {
                                '0': {
                                    key: 'PVWT',
                                    value: 1,
                                    select: QuestionTypeEnum.INPUT,
                                    answers: [
                                        {
                                            title: '1',
                                            value: 1,
                                            selected: true,
                                        },
                                    ],
                                    question:
                                        'Workers requiring tools for paving',
                                },
                                fragments: [],
                                item_types: [
                                    {
                                        id: 536,
                                        qty: 1,
                                        data: null,
                                        slug: null,
                                        tool: true,
                                        unit: 'each',
                                        items: [],
                                        labor: false,
                                        title: 'Club Hammer',
                                        created_at:
                                            '2024-07-05T11:08:17.000000Z',
                                        deleted_at: null,
                                        updated_at:
                                            '2024-11-30T14:39:31.000000Z',
                                        qty_formula: 'f(x) = %PVWT%',
                                        ordered_qty: 0,
                                        percentage: 0,
                                        fair_market_price: null,
                                    },
                                    {
                                        id: 631,
                                        qty: 1,
                                        data: null,
                                        slug: null,
                                        tool: true,
                                        unit: 'each',
                                        fair_market_price: null,
                                        items: [
                                            {
                                                id: 1295,
                                                qty: 1,
                                                unit: 'each',
                                                price: '24.304348',
                                                title: 'Black Leaf Rake',
                                                admined: true,
                                                packaging: [],
                                                created_at:
                                                    '2024-04-19T15:42:14.000000Z',
                                                deleted_at: null,
                                                updated_at:
                                                    '2025-03-04T12:43:12.000000Z',
                                                qty_from_store: 7,
                                                ordered_qty: 0,
                                                percentage: 0,
                                                galleries: [],
                                                pivot: undefined,
                                                uuid: undefined,
                                            },
                                        ],
                                        labor: false,
                                        title: 'Rake',
                                        created_at:
                                            '2024-08-01T07:18:24.000000Z',
                                        deleted_at: null,
                                        updated_at:
                                            '2024-12-02T08:39:08.000000Z',
                                        qty_formula: 'f(x) = %PVWT%',
                                        ordered_qty: 0,
                                        percentage: 0,
                                    },
                                    {
                                        id: 923,
                                        qty: 1,
                                        data: null,
                                        slug: null,
                                        tool: true,
                                        unit: 'each',
                                        items: [],
                                        labor: false,
                                        title: 'Measuring Tape',
                                        created_at:
                                            '2024-08-01T07:18:54.000000Z',
                                        deleted_at: null,
                                        updated_at:
                                            '2024-12-02T08:32:28.000000Z',
                                        qty_formula: 'f(x) = %PVWT%',
                                        ordered_qty: 0,
                                        percentage: 0,
                                        fair_market_price: null,
                                    },
                                    {
                                        id: 1171,
                                        qty: 1,
                                        data: null,
                                        slug: null,
                                        tool: true,
                                        unit: 'each',
                                        fair_market_price: null,
                                        items: [
                                            {
                                                id: 7989,
                                                qty: 1,
                                                unit: 'each',
                                                price: '52.130435',
                                                title: 'Line Level Plastic',
                                                admined: true,
                                                packaging: [],
                                                created_at:
                                                    '2024-04-19T17:12:05.000000Z',
                                                deleted_at: null,
                                                updated_at:
                                                    '2025-03-04T12:51:49.000000Z',
                                                qty_from_store: 4,
                                                ordered_qty: 0,
                                                percentage: 0,
                                                galleries: [],
                                                pivot: undefined,
                                                uuid: undefined,
                                            },
                                        ],
                                        labor: false,
                                        title: 'Level',
                                        created_at:
                                            '2024-08-01T07:19:39.000000Z',
                                        deleted_at: null,
                                        updated_at:
                                            '2024-12-02T08:27:30.000000Z',
                                        qty_formula: 'f(x) = %PVWT%',
                                        ordered_qty: 0,
                                        percentage: 0,
                                    },
                                    {
                                        id: 1295,
                                        qty: 1,
                                        data: null,
                                        slug: null,
                                        tool: true,
                                        unit: 'each',
                                        fair_market_price: null,
                                        items: [
                                            {
                                                id: 7903,
                                                qty: 1,
                                                unit: 'each',
                                                price: '150.391304',
                                                title: 'Cold Chisel 20x250mm',
                                                admined: true,
                                                packaging: [],
                                                created_at:
                                                    '2024-04-19T17:10:45.000000Z',
                                                deleted_at: null,
                                                updated_at:
                                                    '2025-03-04T12:51:46.000000Z',
                                                qty_from_store: 11,
                                                ordered_qty: 0,
                                                percentage: 0,
                                                galleries: [],
                                                pivot: undefined,
                                                uuid: undefined,
                                            },
                                        ],
                                        labor: false,
                                        title: 'Chisel',
                                        created_at:
                                            '2024-08-01T07:20:20.000000Z',
                                        deleted_at: null,
                                        updated_at:
                                            '2024-12-02T08:26:05.000000Z',
                                        qty_formula: 'f(x) = %PVWT%',
                                        ordered_qty: 0,
                                        percentage: 0,
                                    },
                                    {
                                        id: 1691,
                                        qty: 1,
                                        data: null,
                                        slug: null,
                                        tool: true,
                                        unit: 'each',
                                        fair_market_price: null,
                                        items: [
                                            {
                                                id: 9936,
                                                qty: 1,
                                                unit: 'each',
                                                price: '373.869565',
                                                title: 'Black & Decker 710w 115mm Small Angle Grinder',
                                                admined: true,
                                                packaging: [],
                                                created_at:
                                                    '2024-04-19T18:12:19.000000Z',
                                                deleted_at: null,
                                                updated_at:
                                                    '2025-03-04T12:54:10.000000Z',
                                                qty_from_store: 4,
                                                ordered_qty: 0,
                                                percentage: 0,
                                                galleries: [],
                                                pivot: undefined,
                                                uuid: undefined,
                                            },
                                        ],
                                        labor: false,
                                        title: 'Angle Grinder',
                                        created_at:
                                            '2024-11-30T15:15:59.000000Z',
                                        deleted_at: null,
                                        updated_at:
                                            '2024-11-30T15:15:59.000000Z',
                                        qty_formula: 'f(x) = %PVWT%',
                                        ordered_qty: 0,
                                        percentage: 0,
                                    },
                                ],
                                var_mapping: null,
                            },
                            slug: null,
                            title: 'Paving Tools',
                            frozen: false,
                            publish: true,
                            created_at: '2024-12-02T13:30:28.000000Z',
                            deleted_at: null,
                            updated_at: '2025-02-25T23:10:00.000000Z',
                        },
                    ],
                    summary_item_types_template: [],
                },
                paid: false,
                slug: 'Paving',
                title: 'Paving',
                bought: false,
                frozen: false,
                counted: true,
                publish: true,
                reviews: 202,
                categories: [
                    {
                        id: 1,
                        slug: null,
                        category: 'DIY',
                        created_at: '2024-05-27T15:02:05.000000Z',
                        deleted_at: null,
                        updated_at: '2024-11-20T08:23:54.000000Z',
                        description: '',
                    },
                ],
                created_at: '2024-12-10T17:09:10.000000Z',
                deleted_at: null,
                updated_at: '2025-05-15T10:04:59.000000Z',
                description: 'templates/a6dece74e38ba86b160c13f43dcf9632.html',
                short_description:
                    'Pave any external area with the pavers of your choice, including all the accessories and tools you require.',
                template_group_id: null,
            },
        ],
    },
    progress: 0,
    store_id: 323,
    target_date: '2025-05-16 00:00:00',
    created_at: '2025-05-15T14:15:02.000000Z',
    updated_at: '2025-05-15T14:15:19.000000Z',
    deleted_at: null,
    lock: false,
    galleries: [],
    address: {
        id: 725,
        address: '5 Newclare Rd, Industria, Johannesburg, 2093, South Africa',
        full_address:
            '5 Newclare Rd, Industria, Johannesburg, 2093, Южная Африка',
        latitude: '-26.20214590330596',
        longitude: '27.98230662569977',
        project_id: 576,
        bill_of_materials_project_id: null,
        created_at: '2025-05-15T14:15:02.000000Z',
        updated_at: '2025-05-15T14:15:02.000000Z',
        deleted_at: null,
        architect_project_id: null,
    },
};
